export const products = {
  all_products: "products/store/",
  single_product: (id: number) => `products/store/get-by/?id=${id}`,
  get_categories: "products/category/",
  get_categories_attribute: "products/category/attribute/",
  get_brands: "products/brand/",
  get_currency: "products/currency/",
  get_all_variants: (product_id: number) =>
    `products/variant/store/?product_id=${product_id}`,
  get_all_product_variants: "/products/store/all/",
  get_variant_by_id: (id: number, product_id: number) =>
    `products/variant/store/get-by/?id=${id}&product_id=${product_id}`,
  create_product: "products/store/",
  create_product_variant: "products/variant/store/",
  create_product_variant_image: (product_id: number) =>
    `products/variant/image/store/?product_id=${product_id}`,
  update_product: (id: number) => `products/store/?id=${id}`,
  update_product_variant: (id: number) => `products/variant/store/?id=${id}`,
  update_product_variant_image: (id: number, product_id: number) =>
    `products/variant/image/store/?id=${id}&product_id=${product_id}`,
  delete_product: (id: number) => `products/store/?id=${id}`,
  delete_product_variant: (id: number, product_id: number) =>
    `products/variant/store/?id=${id}&product_id=${product_id}`,
};
